module.exports = __webpack_public_path__ + "static/sample-projects-11-4f5d3574e464d857db785a018db41636.png";